import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CheckoutForm = ({booking}) => {
    const [clientSecret, setClientSecret] = useState('');
    const [cardError, setCardError] = useState('');
    const [success, setSuccess] = useState('');
    const [processing, setProcessing] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const {price, patient, email, _id, treatment} = booking;
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();

    useEffect(() => {
        fetch('https://doctors-portal-server-puce-two.vercel.app/create-payment-intent',{
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `bearer ${localStorage.getItem('accessToken')}`
            },
            body: JSON.stringify({price})
        })
        .then(res=>res.json())
        .then(data=>{
            setClientSecret(data.clientSecret)
        })
    }, [price]);


    const handleSubmit = async(event)=>{
        event.preventDefault();
        if (!stripe || !elements) {
            return;
        }

        const card = elements.getElement(CardElement);
        if (card == null) {
            return
        }

        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card
        })
        if (error) {
            console.log(error);
            setCardError(error.message);
        }else{
            setCardError('')
            console.log('[PaymentMethod]', paymentMethod);
        }
        setSuccess('');
        setProcessing(true);
        const {paymentIntent, error:confirmError} = await stripe.confirmCardPayment(
            clientSecret,
                {
                payment_method: {
                    card: card,
                    billing_details: {
                        name: patient,
                        email: email
                        },
                    },
                },
            );
            if (confirmError) {
              setCardError(confirmError.message)
              return
            }
            if(paymentIntent.status === 'succeeded'){
                console.log('card info', card);
                const payment = {
                    price,
                    transactionId: paymentIntent.id,
                    email,
                    bookingId: _id,
                    treatment,

                }
                fetch('https://doctors-portal-server-puce-two.vercel.app/payments',{
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                        authorization: `bearer ${localStorage.getItem('accessToken')}`
                    },
                    body: JSON.stringify(payment)
                })
                .then(res=>res.json())
                .then(data=> {
                    console.log(data);
                    if (data.insertedId) {
                        setSuccess('Your payment is completed successfully')
                        setTransactionId(paymentIntent.id);
                    }
                })
            }
            setProcessing(false);
            console.log('paymentIntent', paymentIntent);
            navigate('/dashboard');

        
    }
    return (
        <div>
            <form onSubmit={handleSubmit}>
            <CardElement
                options={{
                    style: {
                        base: {
                        fontSize: '16px',
                        color: '#424770',
                        '::placeholder': {
                            color: '#aab7c4',
                        },
                        },
                        invalid: {
                        color: '#9e2146',
                        },
                    },
                }}
            />
            <button className='btn btn-sm mt-5' type="submit" disabled={!stripe || !clientSecret || processing}>
                Pay
            </button>
            </form>
            <p className='text-red-600'>{cardError}</p>
            {
                success && <div>
                    <p className='text-green-600'>{success}</p>
                    <p>Your transaction id: <span className='font-bold'>{transactionId}</span></p>
                </div>
            }
        </div>
    );
};

export default CheckoutForm;